/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BookAppointmentDto,
  ErrorResponse,
  UpdateOwnProfileDto,
} from '../models/index';
import {
    BookAppointmentDtoFromJSON,
    BookAppointmentDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    UpdateOwnProfileDtoFromJSON,
    UpdateOwnProfileDtoToJSON,
} from '../models/index';

export interface BookAppointmentRequest {
    bookAppointmentDto: BookAppointmentDto;
}

export interface UpdateOwnProfileRequest {
    updateOwnProfileDto: UpdateOwnProfileDto;
}

/**
 * 
 */
export class ExamplePatientProfileApi extends runtime.BaseAPI {

    /**
     * Book a new appointment
     */
    async bookAppointmentRaw(requestParameters: BookAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['bookAppointmentDto'] == null) {
            throw new runtime.RequiredError(
                'bookAppointmentDto',
                'Required parameter "bookAppointmentDto" was null or undefined when calling bookAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/profile/appointments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookAppointmentDtoToJSON(requestParameters['bookAppointmentDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Book a new appointment
     */
    async bookAppointment(requestParameters: BookAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bookAppointmentRaw(requestParameters, initOverrides);
    }

    /**
     * Get own appointments
     */
    async getOwnAppointmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/profile/appointments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get own appointments
     */
    async getOwnAppointments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getOwnAppointmentsRaw(initOverrides);
    }

    /**
     * Get own patient profile
     */
    async getOwnProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get own patient profile
     */
    async getOwnProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getOwnProfileRaw(initOverrides);
    }

    /**
     * Update own patient profile
     */
    async updateOwnProfileRaw(requestParameters: UpdateOwnProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateOwnProfileDto'] == null) {
            throw new runtime.RequiredError(
                'updateOwnProfileDto',
                'Required parameter "updateOwnProfileDto" was null or undefined when calling updateOwnProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient/profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOwnProfileDtoToJSON(requestParameters['updateOwnProfileDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update own patient profile
     */
    async updateOwnProfile(requestParameters: UpdateOwnProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOwnProfileRaw(requestParameters, initOverrides);
    }

}
